<template>
    <b-row v-if="fileData" class="shared-file">
        <b-col cols="1"></b-col>
        <b-col cols="4">
            <b-card>
                <p>
                    <strong>{{ fileData.title }}</strong>
                </p>
                <p>{{ $t('general.' + fileType.toLowerCase()) }}</p>
                <p>
                    <icon name="flag"></icon>
                    {{ fileData.created | formatDate }}
                </p>
                <p>
                    <icon name="pencil"></icon>
                    {{ fileData.modified | formatDateTime }}
                </p>
                <p>
                    <icon name="database"></icon>
                    {{ fileData.fileSize }} Bytes
                </p>
                <p>
                    <icon name="info"></icon>
                    {{ getFileTypeExtension(fileData) || 'FILE'}}
                </p>
                <hr>
                <b-btn block type="button" @click.stop="downloadFile" v-show="projectPermissions.includes('DOWNLOAD_FILE')">
                    <icon name="download"></icon>
                    {{ $t('files.context.download') }}
                </b-btn>
            </b-card>
        </b-col>
        <b-col cols="6">
            <document-thumbnail :is-share="true" :document-id="fileData.id" class="linked-file-preview"></document-thumbnail>
        </b-col>
            <b-col cols="1"></b-col>
    </b-row>
</template>

<script>
import utils from '../Utils.js';
import projectsApi from '../api/projects.js';
import DocumentThumbnail from './Shared/DocumentThumbnail';

export default {
    components: {
        DocumentThumbnail
    },
    data() {
        return {
            fileData: null
        }
    },
    computed: {
        fileType() {
            return this.fileData ? this.fileData.type : '';
        },
        baseUrl() {
            return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        },
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },
    created() {
        this.$store.dispatch('system/loadGlobalConfiguration');

        let shareToken = this.$route.params.shareToken;
        projectsApi.getFileShareData(shareToken)
            .then((result) => {
                this.fileData = result.data;
            }).catch((err) => {
                console.log(err);
            });
    },
    methods: {
        downloadFile() {
            let { shareToken } = this.$route.params;
            let rawFileTitle = `${this.fileData.title}.${utils.getFileTypeExtension(this.fileData).toLowerCase()}`;
            let encodedFileTitle = encodeURIComponent(rawFileTitle);

            let url = `${this.baseUrl}/colab/epr/public/share/${shareToken}/download?title=${encodedFileTitle}`;
            window.location.href = url;
        },
        getFileTypeExtension(file) {
			return utils.getFileTypeExtension(file);
		},
    }
}
</script>

